import { IpaType } from "../../phonemes/ipa";
import { segmentPhonemes } from "../../phonemes/segmentPhonemes";
import { SegmentStrategy } from "../../rules/intoSegments";
import { PhoneLengths } from "../../rules/lengthRules";
import { RuleSet } from "../../rules/ruleSet";
import { RulesRunner } from "../../rules/rulesRunner";
import { AllRules, SupportedAccent } from "../../ruleSets/allRules";
import { InputType } from "./inputOptions";

/** handle rules, accents, custom IPA rules */
export class HandleRules {
  private customIpaRule = new RulesRunner({ inputSegments: SegmentStrategy.Single, preprocess: ['normIpa'] });

  /** set rule to use when language='IPA' */
  setCustomIpaRule(rules: RuleSet): void {
    this.customIpaRule = new RulesRunner(rules);
  }

  /** convert 'input' to IPA using current language & optional accent */
  convert(
    input: string, inputType: InputType, accent: SupportedAccent
  ): { ipa: IpaType, afterRules: IpaType, badLanguage?: string[] } {
    const rules = AllRules.get();
    if (inputType === 'IPA') {
      // apply custom IPA rule
      const ipaResult = this.customIpaRule.runRulesOnIpa(input);
      // check for unknown IPA by segmenting
      const segments = segmentPhonemes(input, 'ipaPlus');
      const allBad = !segments.hasUnknown ? undefined : segments.phonemes.filter(p => p.meta === 'unknown').map(p => p.phoneme);
      const badLanguage = allBad === undefined ? undefined : AllRules.deDupe(allBad)
      /*
      const unknowns = ipaResult.hasUnknowns ? ipaResult.hasUnknowns.map(u => u.phoneme) : undefined;
      const badLanguage = unknowns !== undefined ? AllRules.deDupe(unknowns) : unknowns;
      */
      return { ipa: ipaResult.ipa, afterRules: '', badLanguage };
    } else if (inputType === 'English (US)' || inputType === 'English (UK)') {
      // return dictionary lookup & applied accent
      const dictAccent: SupportedAccent = inputType === 'English (US)' ? 'Dictionary US' : 'Dictionary UK';
      const langResult = rules.convert(input, 'English', dictAccent);
      const accResult = rules.convert(input, 'English', accent);
      return { ipa: langResult.afterRules, afterRules: accResult.afterRules, badLanguage: langResult.badInput };
    } else if (inputType === 'Spanish') {
      // return base Spanish & applied accent
      const langResult = rules.convert(input, 'Spanish');
      const accResult = rules.convert(input, 'Spanish', accent);
      return { ipa: langResult.afterRules, afterRules: accResult.afterRules, badLanguage: langResult.badInput };
    }
    // all other rules
    const result = rules.convert(input, inputType);
    return { ...result, ipa: result.afterRules };
  }

  /** get phoneme length rules for given language & optional accent */
  getAddPhonemeLength(inputType: InputType, accent: SupportedAccent): PhoneLengths | undefined {
    const rules = AllRules.get();
    switch (inputType) {
      case 'IPA':
        return this.customIpaRule.getAddPhonemeLength();
      case 'English (US)':
      case 'English (UK)':
        return rules.getAddPhonemeLength('English', accent);
      default:
        return rules.getAddPhonemeLength(inputType, accent);
    }
  }
}
